import { Link } from 'react-router'

import { cn } from '@shared/lib/cn'

import styles from './styles.module.scss'

interface ProductGroupMenuItemProps {
  title: string
  url: string
  icon?: string
  className?: string
  category?: string
}

export function ProductGroupMenuItem ({ title, url, icon, className, category }: ProductGroupMenuItemProps) {
  const iconToRender = icon ?? '/icons/empty.svg'

  return (
    <Link
      to={url}
      className={cn(styles.productGroupMenuItem, className)}
      data-category={category}
    >
      <div className={styles.productGroupMenuItem__icon}>
        <img
          src={iconToRender}
          alt={title}
          className={styles.productGroupMenuItem__img}
        />
      </div>
      <span className={styles.productGroupMenuItem__text}>{title}</span>
    </Link>
  )
}
